<script>
  import { Line, mixins } from 'vue-chartjs';

  const { reactiveProp } = mixins;

  export default {

    extends: Line,

    mixins: [reactiveProp],

    props: ['options', 'chartId'],

    mounted() {
      this.renderChart(this.chartData, this.options);
      // console.log(this.$data._chart);
    },

  };

</script>



// WEBPACK FOOTER //
// src/components/Station/Chart.vue